import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-linkedin',
  templateUrl: './icon-linkedin.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconLinkedinComponent {}
